/* eslint-disable */
// ---------------------------------------------------------
// GENERATED FILE — DO NOT EDIT.
// Source: functions/src/serviceEngine/
// Regenerate with: npm run gen:engine
// ---------------------------------------------------------

// Canonical Service Engine — recurrence matching.
//
// Phase 1 extraction (Workstream A): these functions were moved verbatim from
// functions/src/presence/checkin.js with no behavioral change. They answer the
// single platform question "does this template occur on this local date?" given
// pre-computed local date parts and weekday. No timezone or Firestore logic here.

function monthDiffParts(start, current) {
  return (current.year - start.year) * 12 + (current.month - start.month);
}

// Phase 2: shared organization-LOCAL "YYYY-MM-DD" key, built from the local date
// parts the caller computed in the org timezone (timezone-correct, not UTC-based).
// Single implementation shared by EXDATE and RDATE.
function localDateKey(parts) {
  return `${String(parts.year).padStart(4, "0")}-${String(parts.month).padStart(2, "0")}-${String(parts.day).padStart(2, "0")}`;
}

// Phase 2: EXDATE — excluded local dates.
function isExcludedDate(parts, exdate) {
  if (!Array.isArray(exdate) || exdate.length === 0) return false;
  return exdate.indexOf(localDateKey(parts)) !== -1;
}

// Phase 2: RDATE — additional local dates.
function isIncludedRdate(parts, rdate) {
  if (!Array.isArray(rdate) || rdate.length === 0) return false;
  return rdate.indexOf(localDateKey(parts)) !== -1;
}

// Phase 2: monthly ordinal weekdays (RFC 5545 BYDAY+BYSETPOS semantics).
function daysInMonth(year, month) {
  // month is 1-based; day 0 of the next month is the last day of this month.
  return new Date(Date.UTC(year, month, 0)).getUTCDate();
}

function isMonthlyOrdinal(ordinal) {
  return ordinal === 1 || ordinal === 2 || ordinal === 3 || ordinal === 4 || ordinal === -1;
}

function matchesMonthlyOrdinalWeekday(parts, weekday, ordinal, daysOfWeek) {
  const target = Array.isArray(daysOfWeek) && daysOfWeek.length ? daysOfWeek[0] : "";
  if (!target || weekday !== target) return false;
  if (ordinal === -1) {
    // "last": no further occurrence of this weekday remains in the month.
    return parts.day + 7 > daysInMonth(parts.year, parts.month);
  }
  const occurrence = Math.floor((parts.day - 1) / 7) + 1;
  return occurrence === ordinal;
}

function serviceTemplateMatchesParts(template, parts, weekday) {
  if (!template.enabled || !template.showInCheckIn) return false;
  // EXDATE takes precedence over RDATE (RFC 5545): an excluded local date never
  // produces an occurrence, even if the same date is also an RDATE.
  if (isExcludedDate(parts, template.exdate)) return false;
  // RDATE: an explicitly-added local date produces an occurrence regardless of the
  // recurrence rule. The caller's day-loop visits each local date once, so a date
  // that is both an RDATE and rule-produced yields exactly one occurrence.
  if (isIncludedRdate(parts, template.rdate)) return true;
  const start = template.startParts;
  if (start) {
    if (parts.year < start.year) return false;
    if (parts.year === start.year && parts.month < start.month) return false;
    if (parts.year === start.year && parts.month === start.month && parts.day < start.day) return false;
  }
  if (template.frequency === "one_time") {
    return start && parts.year === start.year && parts.month === start.month && parts.day === start.day;
  }
  if (template.frequency === "weekly") {
    if (!template.daysOfWeek.includes(weekday)) return false;
    if (!start) return true;
    const elapsedDays = Math.floor(
      (Date.UTC(parts.year, parts.month - 1, parts.day) - Date.UTC(start.year, start.month - 1, start.day)) /
        (24 * 60 * 60 * 1000)
    );
    return elapsedDays >= 0 && Math.floor(elapsedDays / 7) % template.interval === 0;
  }
  if (template.frequency === "monthly") {
    const diff = start ? monthDiffParts(start, parts) : 0;
    if (diff < 0 || diff % template.interval !== 0) return false;
    // Ordinal weekday (e.g. first Friday, last Sunday) takes precedence when set;
    // otherwise fall back to the existing day-of-month behavior (backward compatible).
    if (isMonthlyOrdinal(template.ordinal)) {
      return matchesMonthlyOrdinalWeekday(parts, weekday, template.ordinal, template.daysOfWeek);
    }
    return parts.day === template.dayOfMonth;
  }
  if (template.frequency === "quarterly") {
    const diff = start ? monthDiffParts(start, parts) : 0;
    return diff >= 0 && diff % (3 * template.interval) === 0 && parts.day === template.dayOfMonth;
  }
  if (template.frequency === "annually") {
    return parts.month === template.monthOfYear && parts.day === template.dayOfMonth;
  }
  return template.daysOfWeek.includes(weekday);
}

// Phase 2: RECURRENCE-ID occurrence overrides (pure overlay; no I/O, no require).
//
// An exception targets one occurrence by its organization-local date. The caller
// loads it (dormant unless the template's exceptionSummary indicates exceptions
// exist) and passes it here as plain data. The engine only overlays permitted
// fields onto a caller-built occurrence draft; it never computes instants or
// reads Firestore. Check-in windows are recomputed by the caller from the
// (possibly overridden) start/end + offsets in the returned draft.

// Identity/recurrence fields an exception must NEVER change (silently ignored):
// serviceType forms the occurrence document identity; the rest anchor the series
// or the exception's own target-date identity.
const IMMUTABLE_OVERRIDE_KEYS = [
  "serviceType",
  "recurrenceId",
  "templateId",
  "timeZone",
  "frequency",
  "interval",
  "daysOfWeek",
  "ordinal",
  "dayOfMonth",
  "monthOfYear",
  "startDate",
  "exdate",
  "rdate",
];

// Exception metadata keys that are not occurrence content.
const EXCEPTION_META_KEYS = ["type", "cancel", "createdAt", "createdByUid", "updatedAt", "exceptionSummary"];

// Nested policy objects that merge field-by-field rather than replacing wholesale.
const OVERLAY_MERGE_KEYS = ["checkIn", "visibility", "location", "online"];

function isOccurrenceCancelled(exception) {
  return Boolean(exception) && (exception.type === "cancel" || exception.cancel === true);
}

function applyOccurrenceOverride(occurrence, exception) {
  // No exception, or a cancellation, leaves the draft untouched (the caller
  // suppresses cancelled occurrences via isOccurrenceCancelled).
  if (!exception || isOccurrenceCancelled(exception)) return occurrence;
  const result = { ...occurrence };
  Object.keys(exception).forEach((key) => {
    if (IMMUTABLE_OVERRIDE_KEYS.indexOf(key) !== -1) return; // immutable: ignored
    if (EXCEPTION_META_KEYS.indexOf(key) !== -1) return; // metadata: not content
    const value = exception[key];
    if (value === undefined || value === null) return; // absent field inherits
    if (
      OVERLAY_MERGE_KEYS.indexOf(key) !== -1 &&
      value &&
      typeof value === "object" &&
      result[key] &&
      typeof result[key] === "object"
    ) {
      result[key] = { ...result[key], ...value }; // nested field-by-field merge
    } else {
      result[key] = value; // scalar / top-level replace
    }
  });
  return result;
}

export {
  serviceTemplateMatchesParts,
  monthDiffParts,
  isOccurrenceCancelled,
  applyOccurrenceOverride,
};
